/**
 * Action types for mac ACL functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_MAC_ACL = 'GET_MAC_ACL';
export const GET_MAC_ACL_SUCCESS = 'GET_MAC_ACL_SUCCESS';
export const GET_MAC_ACL_FAIL = 'GET_MAC_ACL_FAIL';
export const ADD_MAC_ACL = 'ADD_MAC_ACL';
export const ADD_MAC_ACL_START = 'ADD_MAC_ACL_START'
export const ADD_MAC_ACL_SUCCESS = 'ADD_MAC_ACL_SUCCESS';
export const ADD_MAC_ACL_FAIL = 'ADD_MAC_ACL_FAIL';
export const EDIT_MAC_ACL = 'EDIT_MAC_ACL'
export const EDIT_MAC_ACL_COMPLETE =  'EDIT_MAC_ACL_COMPLETE'
export const DELETE_MAC_ACL = 'DELETE_MAC_ACL';
export const DELETE_MAC_ACL_SUCCESS = 'DELETE_MAC_ACL_SUCCESS';
export const DELETE_MAC_ACL_FAIL = 'DELETE_MAC_ACL_FAIL';





